"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const PlayIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M13.654 9.444a1.654 1.654 0 000-2.888l-7.616-4.33C4.91 1.584 3.5 2.386 3.5 3.669v8.662c0 1.283 1.41 2.085 2.538 1.443l7.616-4.33z"
  })))
});
PlayIcon.displayName = 'PlayIcon';
var _default = exports.default = PlayIcon;